import {
	createRouter,
	createWebHashHistory
} from "vue-router";
import index from "@/views/index.vue";
import home from "@/views/componentsPage/home.vue";
const routes = [{
		path: "/",
		name: "index",
		component: index,
		redirect: "/home",
		children: [
			// 添加子路由
			{
				path: "/home",
				name: "首页",
				component: () => import("@/views/componentsPage/home.vue"),
			},
			{
				path: "/lxwm",
				name: "联系我们",
				component: () => import("@/views/componentsPage/lxwm.vue"),
			},
			{
				path: "/ccQyjj",
				name: "企业简介",
				component: () => import("@/views/componentsPage/ccQyjj.vue"),
			},
			{
				path: "/ccZzjg",
				name: "组织架构",
				component: () => import("@/views/componentsPage/ccZzjg.vue"),
			},
			{
				path: "/ccQywh",
				name: "企业文化",
				component: () => import("@/views/componentsPage/ccQywh.vue"),
			},
			{
				path: "/ccYgfc",
				name: "企业风采",
				component: () => import("@/views/componentsPage/ccYgfc.vue"),
			},
			{
				path: "/listDetails",
				name: "详情内容",
				component: () => import("@/components/listDetails.vue"),
			},
			{
				path: "/listDetails_third",
				name: "信息详情",
				component: () => import("@/components/listDetails_third.vue"),
			},
			{
				path: "/fileDetails_third",
				name: "信息详情",
				component: () => import("@/components/fileDetails_third.vue"),
			},
			{
				path: "/ccCcjb",
				name: "国投简报",
				component: () => import("@/views/componentsPage/ccCcjb.vue"),
			},
			{
				path: "/ccMtbd",
				name: "媒体报道",
				component: () => import("@/views/componentsPage/ccMtbd.vue"),
			},
			{
				path: "/ccGzdt",
				name: "工作动态",
				component: () => import("@/views/componentsPage/ccGzdt.vue"),
			},
			{
				path: "/ccXmdt",
				name: "项目动态",
				component: () => import("@/views/componentsPage/ccXmdt.vue"),
			},
			{
				path: "/ccGsggCv",
				name: "公司公告",
				component: () => import("@/views/componentsPage/ccGsggCv.vue"),
			},
			{
				path: "/ccHzxm",
				name: "合作项目",
				component: () => import("@/views/componentsPage/ccHzxm.vue"),
			},
			{
				path: "/ccHzgs",
				name: "合作公司",
				component: () => import("@/views/componentsPage/ccHzgs.vue"),
			},
			{
				path: "/ccLzjs",
				name: "廉政建设",
				component: () => import("@/views/componentsPage/ccLzjs.vue"),
			},
			{
				path: "/ccTdhd",
				name: "团队活动",
				component: () => import("@/views/componentsPage/ccTdhd.vue"),
			},
			{
				path: "/ccZbgs",
				name: "中标公告",
				component: () => import("@/views/componentsPage/ccZbgs.vue"),
			},
			{
				path: "/ccZbgg",
				name: "招标公告",
				component: () => import("@/views/componentsPage/ccZbgg.vue"),
			},
			{
				path: "/ccGyszc",
				name: "供应商注册",
				component: () => import("@/views/componentsPage/ccGyszc.vue"),
			},
			{
				path: "/ccGyszccx",
				name: "供应商查询",
				component: () => import("@/views/componentsPage/ccGyszccx.vue"),
			},
			{
				path: "/ccZcfg",
				name: "政策法规",
				component: () => import("@/views/componentsPage/ccZcfg.vue"),
			},

			{
				path: "/ccXsdw",
				name: "下属单位",
				component: () => import("@/views/componentsPage/ccXsdw.vue"),
			},
			{
				path: "/ccQyyw",
				name: "企业要闻",
				component: () => import("@/views/componentsPage/ccQyyw.vue"),
			},
			{
				path: "/ccGsxm",
				name: "公司项目",
				component: () => import("@/views/componentsPage/ccGsxm.vue"),
			},
		],
	},
	{
		path: "/fileDetails",
		name: "详情文件",
		component: () => import("../views/fileDetails.vue"),
	},
	// {
	// 	path: "/fileDetails_third",
	// 	name: "招标、中标详情文件",
	// 	component: () => import("../views/fileDetails_third.vue"),
	// }
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

router.beforeEach((to, from, next) => {
	next();
});

export default router;